import request from '@hb/sharp-request';
import { UserPo } from '@/po/user';
import { newGatewayUrl } from '@/constant';

export const getAuthInfo = (
  commodityId: string,
): Promise<UserPo.AuthModule[]> => request.postGate('f.user.setting.modules', { commodityId }, { baseURL: newGatewayUrl });

const UserModulesApi = {
  getAuthInfo,
};

export default UserModulesApi;
